import { MONTHS, formatMoney } from "./constants";

export function getSpendingComparison(selectedMonth: number) {
  const month = MONTHS[selectedMonth];
  const previousMonth = MONTHS[selectedMonth - 1];
  if (previousMonth === undefined) {
    return "First month in this sample. No earlier month to compare.";
  }

  const remaining = month.income - month.expenses;
  const previousRemaining = previousMonth.income - previousMonth.expenses;
  const difference = remaining - previousRemaining;
  if (difference === 0) {
    return `The same amount left after expenses as ${previousMonth.name}.`;
  }

  const direction = difference > 0 ? "more" : "less";
  return `${formatMoney(Math.abs(difference))} ${direction} left after expenses than ${previousMonth.name}.`;
}
